import { useMemo } from "react";
import { number, object } from "yup";
import { FormField } from "./types";
import { BooleanSwitchValue } from "consts/general";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.HasAgreedTermsConditions]: number()
                .oneOf([BooleanSwitchValue.On])
                .required()
        })
    ), []);

export default useValidationSchema;
